import React from 'react';

const VersionToggle: React.FC = () => {
  const switchToStatic = () => {
    localStorage.setItem('preferStatic', 'true');
    window.location.href = '/static-version.html';
  };

  return (
    <div className="version-toggle">
      <button onClick={switchToStatic} className="version-button">
        Switch to Static Version
      </button>
    </div>
  );
};

export default VersionToggle; 